import { IReferee } from "../../../store/superadmin/referral/types";
import { getFormatedDate } from "../../../utils/dataParser";
import StarRating from "../../UI/StarRating";

interface IRefereeItemProps {
  referee: IReferee;
  onClick?: () => void;
}

const RefereeItem = ({ referee, onClick }: IRefereeItemProps) => {
  return (
    <div
      className="d-flex flex-column flex-lg-row gap-20 gap-mobile-5 cursor-pointer"
      onClick={onClick}
    >
      <div className="w-140px fs-13 fw-700 text-decoration-underline text-break">
        {referee?.first_name}
        {referee?.last_name}
      </div>
      <div className="w-120px">
        <StarRating rating={referee.avarage_rating || 0} />
      </div>
      <div className="w-140px fs-13">
        Joined {getFormatedDate(referee.registered_at)}
        { referee.candidate_status !== "verified" ? 
        <div className="text-grey-medium fs-13 fw-400">
          Pending Profile
        </div>  : ""}
      </div>
      <div className="w-120px fs-13">
        {referee.applications_count || 0} Jobs Completed
      </div>
    </div>
  );
};

export default RefereeItem;
